// src/pages/Government.jsx
import React from 'react';

export default function Government() {
  return (
    <section>
      <h1>Government Projects</h1>
      <p>Content coming soon…</p>
    </section>
  );
}
